import React from "react";
import { Icon } from "@iconify/react";
import logo from "../assets/images/logo for oceanic/logo.png";

const Footer = () => {
  return (
    <>
      {/* <div class="pb-[50px] md:px-[30px] footer_container">
        <div class="flex flex-col mx-auto max-w-[1500px] h-auto">
          <div className="xl:flex justify-around w-full mb-[100px] md:mb-[unset]">
            <div class="w-[100%] md:w-[68%] mx-auto xl:w-[38%] text-center xl:text-start px-[13px] md:px-[70px]">
              <div class="flex justify-center text-center md:justify-center xl:justify-start mb-[30px] text-white">
                <img className="h-16 w-[170px]" src={logo} alt="Your Company" />
              </div>

              <div class=" text-center md:text-center xl:text-start text-gray-500 mb-[40px]">
                Oceanic Horrors is a first of its kind PvP/PvE metaverse game
                for web 3.0 gamers and NFT enthusiasts. Each player owns a
                unique terrain NFT in the game that has a vibe of its own and is
                designed differently. Oceanic Horrors stands out from all other
                metaverse games because it is a real-time strategy based first
                person shooting.
              </div>

              <button
                type="button"
                className="flex items-center mx-auto xl:mx-[unset] mb-[70px] gap-3 rounded-full px-10 py-3.5 text-sm font-bold text-white bg-[#451320] shadow-sm ring-1 ring-inset ring-[#7C0B0B] tracking-[2px] hover:bg-black hover:ring-[black]"
              >
                <span> PLAY NOW</span>
                <span>
                  <Icon icon="fluent-mdl2:game" className="text-[25px]" />
                </span>
              </button>
            </div>
            <div class="flex lg:justify-between w-[100%] md:w-[90%] lg:w-[80%] xl:w-[65%] mx-auto flex-col lg:flex-row gap-y-[20px] py-[10px] lg:py-0 px-[15px] sm:px-[30px] md:px-[40px] lg:px-[50px] xl:px-[75px] h-[300px] xl:h-[380px]">
              <div class="md:flex justify-center sm:justify-between flex-wrap sm:flex-nowrap gap-y-[60px] sm:gap-x-[100px] lg:gap-x-[160px] lg:w-7/12">
                <div class=" sm:text-left mb-5">
                  <div class="mb-[18px] text-gray-200 text-[25px] font-bold select-none">
                    PLAY
                  </div>

                  <ul class="flex md:flex-col gap-[14px] text-[17px] text-gray-500">
                    <a class="hover:underline" href="#">
                      <li>Overview</li>
                    </a>
                    <a class="hover:underline" href="#">
                      <li>Features</li>
                    </a>
                    <a class="hover:underline" href="#">
                      <li>Solutions</li>
                    </a>
                    <a class="hover:underline" href="#">
                      <li>Tutorials</li>
                    </a>
                  </ul>
                </div>

                <div class=" sm:text-left mb-5">
                  <div class="mb-[18px] text-gray-200 text-[25px] font-bold select-none">
                    LEARN
                  </div>

                  <ul class="flex md:flex-col gap-[14px] text-[17px] text-gray-500">
                    <a class="hover:underline" href="#">
                      <li>About us</li>
                    </a>
                    <a class="hover:underline" href="#">
                      <li>Careers</li>
                    </a>
                    <a class="hover:underline" href="#">
                      <li>Press</li>
                    </a>
                    <a class="hover:underline" href="#">
                      <li>News</li>
                    </a>
                  </ul>
                </div>

                <div class="text-left mb-5">
                  <div class="mb-[18px] text-gray-200 text-[25px] font-bold select-none">
                    SOCIAL
                  </div>

                  <ul class="min-w-[310px] flex flex-wrap sm:flex-nowrap md:flex-wrap gap-[22px] text-[17px] text-gray-500 flex-row">
                    <li class="w-full w-1/4 md:w-1/3">
                      <a
                        class="hover:underline flex items-center gap-3"
                        href="#"
                      >
                        <span className="bg-[#252525] p-2 rounded-full">
                          <Icon
                            className="text-[darkred] text-[18px]"
                            icon="mdi:twitter"
                          />
                        </span>

                        <span>Twitter</span>
                      </a>
                    </li>
                    <li class="w-full w-1/4 md:w-1/3">
                      <a
                        class="hover:underline flex items-center gap-3"
                        href="#"
                      >
                        <span className="bg-[#252525] p-2 rounded-full">
                          <Icon
                            className="text-[darkred] text-[18px]"
                            icon="ic:outline-email"
                          />
                        </span>

                        <span>Email</span>
                      </a>
                    </li>
                    <li class="w-full w-1/4 md:w-1/3">
                      <a
                        class="hover:underline flex items-center gap-3"
                        href="#"
                      >
                        <span className="bg-[#252525] p-2 rounded-full">
                          <Icon
                            className="text-[darkred] text-[18px]"
                            icon="ic:baseline-discord"
                          />
                        </span>

                        <span>Discord</span>
                      </a>
                    </li>
                    <li class="w-full w-1/4 md:w-1/2">
                      <a
                        class="hover:underline flex items-center gap-3"
                        href="#"
                      >
                        <span className="bg-[#252525] p-2 rounded-full">
                          <Icon
                            className="text-[darkred] text-[18px]"
                            icon="bi:medium"
                          />
                        </span>

                        <span>Medium</span>
                      </a>
                    </li>
                    <li class="w-full w-1/4 md:w-1/2">
                      <a
                        class="hover:underline flex items-center gap-3"
                        href="#"
                      >
                        <span className="bg-[#252525] p-2 rounded-full">
                          <Icon
                            className="text-[darkred] text-[18px]"
                            icon="mdi:youtube"
                          />
                        </span>

                        <span>Youtube</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-[200px] lg:mt-[50px] xl:flex items-center text-center justify-evenly sm:justify-between flex-col sm:flex-row sm:px-[30px] md:px-[40px] lg:px-[50px] xl:px-[75px] w-full">
            <div class="text-gray-500">
              © 2023 Octal Games, All Rights Reserved.
            </div>

            <ul class="flex justify-center gap-[15px] text-gray-500 cursor-pointer">
              <li class="ease-in duration-200 hover:text-gray-100">
                <a href="">Privacy Policy</a>
              </li>
              <li class="ease-in duration-200 hover:text-gray-100">
                <a href="">Terms & Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </div> */}

      <div className="text-center md:flex justify-around items-center pt-[100px] h-[50vh] md:h-[30vh]">
        <div class="flex justify-center text-center md:justify-center xl:justify-start mb-[30px] text-white">
          <img className="h-16 w-[170px]" src={logo} alt="Your Company" />
        </div>
        <div class="text-gray-500 mb-[30px] md:mb-[unset]">
          © 2023, Oceanic Horrors, All Rights Reserved.
        </div>

        <div className="flex justify-center items-center gap-4 text-white">
          <a
            class="hover:underline flex items-center gap-2"
            href="https://twitter.com/OceanicH0rrOr"
            target="_"
          >
            <span className="bg-[#252525] p-2 rounded-full">
              <Icon className="text-[darkred] text-[18px]" icon="mdi:twitter" />
            </span>

            <span>Twitter</span>
          </a>
          <a
            class="hover:underline flex items-center gap-2"
            href="https://t.me/TheOceanicHorror"
            target="_"
          >
            <span className="bg-[#252525] p-2 rounded-full">
              {/* <Icon className="text-[darkred] text-[18px]" icon="mdi:twitter" /> */}

              <Icon className="text-[darkred] text-[18px]" icon="bi:telegram" />
            </span>

            <span>Telegram</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
